export const faqsArray = [
  {
    question: 'What services do you offer?',
    answer:
      'We provide a full range of construction services, including new builds, renovations, extensions, and general contracting for residential and commercial projects.',
  },
  {
    question: 'How can I get a quote for my project?',
    answer:
      'You can request a free quote by visiting our contact page or giving us a call. We’ll discuss your requirements and provide an accurate estimate based on your project’s scope.',
  },
  {
    question: 'Are you fully licensed and insured?',
    answer:
      'Yes, Ascari Building Contractors is fully licensed and insured, ensuring all our work meets safety and quality standards.',
  },
  {
    question: 'How long will my project take?',
    answer:
      'Project timelines vary depending on the scope and complexity. We provide a detailed schedule during the consultation process and keep you updated throughout the build.',
  },
  {
    question: 'Do you handle planning permission and building regulations?',
    answer:
      'Yes, we assist with planning permissions and ensure all work complies with building regulations to make the process smooth and hassle-free for you.',
  },
  {
    question: 'What areas do you cover?',
    answer:
      'We operate across Devon and Cornwall, providing high-quality building services to homeowners and businesses in the region.',
  },
];
